import { Button } from "../ui/button";
import { UiLink } from "../ui/router";

/**
 * The design's `app/not-found.tsx`, rendered by the root route's
 * `notFoundComponent`.
 *
 * Presentational only: it reads no session and issues no query, because it is
 * shown for a path the router could not resolve — including to a visitor with
 * no cookie at all, where a signed-in-only hook would be a second failure on
 * top of the first.
 *
 * The design's primary link is `/overview`; this portal's dashboard is `/`, so
 * that one href is remapped. The other two are the same paths in both.
 */
export function NotFound() {
  return (
    <div className="grid min-h-dvh place-items-center px-6 text-center">
      <div>
        <p className="font-mono text-2xs font-bold tracking-[0.2em] text-brand uppercase">
          404
        </p>
        <h1 className="mt-3 font-display text-3xl font-bold tracking-[-0.02em] text-ink">
          We could not find that page
        </h1>
        <p className="mx-auto mt-3 max-w-md text-base text-ink-3">
          The link may be out of date, or the page may have moved somewhere else in the
          portal.
        </p>
        <div className="mt-6 flex justify-center gap-2">
          <Button href="/">Back to your account</Button>
          <Button href="/wallets" variant="secondary">
            Wallets
          </Button>
        </div>
        <p className="mt-8 text-2xs text-ink-4">
          <UiLink href="/sign-in" className="hover:text-ink-2">
            Sign in
          </UiLink>
        </p>
      </div>
    </div>
  );
}
